import axiosService from '../axios'

export const list = (params?: any) => {
  return axiosService({
    url: '/api.accessary-form',
    method: 'get',
    params,
  })
}

export const listAll = (params?: any) => {
  return axiosService({
    url: '/api.accessary-form/all',
    method: 'get',
    params,
  })
}

export const count = () => {
  return axiosService({
    url: `/api.accessary-form/count-pending`,
    method: 'get',
  })
}

export const get = (id: number) => {
  return axiosService({
    url: `/api.accessary-form/${id}`,
    method: 'get',
  })
}

export const update = (id: number, data: any) => {
  return axiosService({
    url: `/api.accessary-form/${id}`,
    method: 'put',
    data,
  })
}

export const apply = (id: number) => {
  return axiosService({
    url: `/api.accessary-form/${id}/apply`,
    method: 'put',
  })
}

export const reject = (id: number, data: any) => {
  return axiosService({
    url: `/api.accessary-form/${id}/reject`,
    method: 'put',
    data,
  })
}

export const remake = (id: number, data: any) => {
  return axiosService({
    url: `/api.accessary-form/${id}/remake`,
    method: 'put',
    data,
  })
}

export const approve = (id: number, data: any) => {
  return axiosService({
    url: `/api.accessary-form/${id}/approve`,
    method: 'put',
    data,
  })
}

export const complete = (id: number, data: any) => {
  return axiosService({
    url: `/api.accessary-form/${id}/complete`,
    method: 'put',
    data,
  })
}

export const destroy = (id: number) => {
  return axiosService({
    url: `/api.accessary-form/${id}`,
    method: 'delete',
  })
}

export const create = (data: any) => {
  return axiosService({
    url: '/api.accessary-form',
    method: 'post',
    data,
  })
}
